export default () => {
  const color = "#36CFC9";
  return (
    <svg
      width="107"
      height="107"
      viewBox="0 0 107 107"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="53.5" cy="53.5" r="53.5" fill="#EF3948" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.6956 33.1183C35.6178 33.4614 33.8299 35.1448 33.2949 37.2618C33.0419 38.2626 33.2074 39.7546 33.6848 40.7781C34.0608 41.5841 34.4974 42.0476 39.856 47.3294L45.6228 53.0132L39.7335 58.8299C34.657 63.8439 33.7988 64.7459 33.5155 65.3656C32.332 67.9547 33.2545 71.0272 35.5849 72.2577C36.6226 72.8058 37.3158 72.9675 38.593 72.9602C39.7756 72.9535 40.6078 72.7393 41.5451 72.2005C41.8564 72.0217 44.2652 69.7605 46.8981 67.1758C49.531 64.5909 52.0968 62.0788 52.5997 61.5933L53.5142 60.7104L59.1051 66.1902C62.18 69.2041 64.9319 71.829 65.2204 72.0233C65.9544 72.518 66.7046 72.7879 67.7597 72.937C70.2364 73.2868 72.4453 72.1626 73.5142 70.008C73.9875 69.0541 74 68.9923 74 67.6061C74 66.2624 73.9768 66.1363 73.5834 65.3403C73.1461 64.4553 73.3936 64.7096 63.8312 55.3218L61.4009 52.9359L67.0921 47.3619C73.3357 41.2469 73.3994 41.17 73.7104 39.3612C74.3537 35.6199 70.6173 32.29 66.8864 33.2797C65.4426 33.6626 65.0718 33.9741 59.176 39.7551L53.503 45.3174L50.9173 42.7713C41.4209 33.4205 41.5508 33.5327 39.79 33.161C38.8156 32.9554 38.6968 32.9529 37.6956 33.1183Z"
        fill="white"
      />
    </svg>
  );
};
